type ParsedMarkdownTextPart = {
    text: string;
    isBold: boolean;
};

export const markdownBoldTextParser = (markdownText: string): ParsedMarkdownTextPart[] => {
    const parts = markdownText.split(/(__[^_]+__)/);

    return parts
        .filter((part) => part.length > 0)
        .map((part) => {
            if (part.startsWith('__') && part.endsWith('__')) {
                return {
                    text: part.slice(2, -2),
                    isBold: true,
                };
            } else {
                return {
                    text: part,
                    isBold: false,
                };
            }
        });
};
